<div class="control-container">
  <i class="bi bi-volume-up"></i>
  <input
    type="range"
    min="0"
    max="1"
    step="0.01"
    [value]="volume"
    (change)="OnVolumeChange($event)"
  />
  @if (audioService.isEmpty()) {
    <i
      role="button"
      class="bi bi-collection-play clickable jello-horizontal"
      (click)="OnShuffleClick()"
    ></i>
  }
  @if (audioService.canPlay()) {
    <i role="button" class="bi bi-play-fill clickable blink-2" (click)="OnPlayClick()"></i>
  }
  @if (audioService.canPause()) {
    <i role="button" class="bi bi-pause-fill clickable blink-2" (click)="OnPauseClick()"></i>
  }
  <div class="buttonContainer">
    @for (button of buttons().slice(); track trackById($index, button)) {
      <button
        type="button"
        class="btn btn-primary"
        (click)="buttonClick($event, button)"
        [contextMenuTrigger]="menu"
        [menuContext]="button"
      >
        {{ button.text }}
      </button>
    }
  </div>
  <i role="button" class="bi bi-trash3 clickable" (click)="OnStopClick()"></i>
</div>
